import { ApiCore } from "./core";
import { apiProvider } from "./core/provider";

const url = "reports";

const apiReports = new ApiCore({
  list: false,
  get: false,
  post: false,
  put: false,
  patch: false,
  delete: false,
  url: url,
});

apiReports.getZipCodeHeatMap = function(from, to) {
  const fromTimestamp = new Date(from).getTime();
  const toTimestamp = new Date(to).getTime();
  return apiProvider.get(`${url}/zipCodeHeatMap?from=${fromTimestamp}&to=${toTimestamp}`);
};

apiReports.getIncomingMap = function() {
  return apiProvider.get(`${url}/incoming-map`);
};

apiReports.getIncomingMonthlyTrend = function() {
  return apiProvider.get(`${url}/incoming-monthly-trend`);
};

apiReports.getPipeline = function() {
  return apiProvider.get(`${url}/pipeline`);
};

apiReports.getPenaltyRisk = function() {
  return apiProvider.get(`${url}/penaltyrisk`);
};

apiReports.claimPenaltyRisk = function(inspectionId, noAction = false) {
  return apiProvider.post(`${url}/penaltyrisk/claim`, { inspectionId, noAction });
};

apiReports.releasePenaltyRisk = function(inspectionId) {
  return apiProvider.post(`${url}/penaltyrisk/release`, { inspectionId });
};

apiReports.setPenaltyRiskClaimState = function(inspectionId, noAction) {
  return apiProvider.post(`${url}/penaltyrisk/claimstate`, { inspectionId, noAction });
};

apiReports.getMetricHistory = function(metric, days = 30) {
  return apiProvider.get(`${url}/metric-history?metric=${encodeURIComponent(metric)}&days=${days}`);
};

apiReports.getNewAreas = function() {
  return apiProvider.get(`${url}/new-areas`);
};

apiReports.getInspectorCoverage = function(minutes = 60) {
  return apiProvider.get(`${url}/inspector-coverage?minutes=${encodeURIComponent(minutes)}`);
};

apiReports.getInspectorUtilisation = function(days = 30) {
  return apiProvider.get(`${url}/inspector-utilisation?days=${encodeURIComponent(days)}`);
};

apiReports.getInspectorUtilisationDetail = function(userId, days = 30) {
  return apiProvider.get(`${url}/inspector-utilisation/${encodeURIComponent(userId)}?days=${encodeURIComponent(days)}`);
};

apiReports.getAreaUtilisationDetail = function(workAreaId, days = 30) {
  return apiProvider.get(`${url}/area-utilisation/${encodeURIComponent(workAreaId)}?days=${encodeURIComponent(days)}`);
};

apiReports.generateNaturalLanguageReport = function(prompt) {
  return apiProvider.post(`${url}/natural-language`, { prompt });
};

apiReports.getSavedNaturalLanguageReports = function() {
  return apiProvider.get(`${url}/natural-language/saved`);
};

apiReports.saveNaturalLanguageReport = function(report) {
  return apiProvider.post(`${url}/natural-language/saved`, report);
};

apiReports.runSavedNaturalLanguageReport = function(id) {
  return apiProvider.post(`${url}/natural-language/saved/${encodeURIComponent(id)}/run`);
};

apiReports.getOutOfArea = function(thresholdMinutes = 120) {
  return apiProvider.get(`${url}/out-of-area?thresh=${thresholdMinutes}`);
};

apiReports.spotCheckOutOfArea = function(lat, lng, thresholdMinutes = 120) {
  return apiProvider.get(`${url}/out-of-area/spot?lat=${lat}&lng=${lng}&thresh=${thresholdMinutes}`);
};

apiReports.getOutOfAreaBatches = function() {
  return apiProvider.get(`${url}/out-of-area/batches`);
};

apiReports.createOutOfAreaBatch = function(policyNos) {
  return apiProvider.post(`${url}/out-of-area/batches`, { policyNos });
};

apiReports.returnOutOfAreaBatch = function(id, returnedAt) {
  return apiProvider.post(`${url}/out-of-area/batches/${id}/return`, { returnedAt });
};

apiReports.getHealthMap = function(days = 30) {
  return apiProvider.get(`${url}/health-map?days=${encodeURIComponent(days)}`);
};

apiReports.getCompletedStats = function() {
  return apiProvider.get(`${url}/completed`);
};


apiReports.getSchedulerUtilisation = function(days = 30, month = "") {
  const m = month ? `&month=${encodeURIComponent(month)}` : "";
  return apiProvider.get(`${url}/scheduler-utilisation?days=${encodeURIComponent(days)}${m}`);
};

apiReports.getSchedulerUtilisationDetail = function(userId, days = 30, month = "") {
  const m = month ? `&month=${encodeURIComponent(month)}` : "";
  return apiProvider.get(`${url}/scheduler-utilisation/${encodeURIComponent(userId)}?days=${encodeURIComponent(days)}${m}`);
};

apiReports.getSchedulerActivityToday = function(userId) {
  const person = userId == null ? "" : `/${encodeURIComponent(userId)}`;
  return apiProvider.get(`${url}/scheduler-utilisation${person}?today=1&days=1`).then((response) => {
    const result = response.data.result;
    const days = userId == null ? result?.summary?.days : result?.windowDays;
    if (response.data.status === 200 && days !== 1) {
      throw new Error("Expected today's scheduler activity, received a different reporting period.");
    }
    return response;
  });
};

apiReports.getSchedulerMonthlyTrend = function() {
  return apiProvider.get(`${url}/scheduler-utilisation/monthly-trend`);
};

apiReports.getSchedulerAreaUtilisationDetail = function(workAreaId, days = 30, month = "") {
  const m = month ? `&month=${encodeURIComponent(month)}` : "";
  return apiProvider.get(`${url}/scheduler-area-utilisation/${encodeURIComponent(workAreaId)}?days=${encodeURIComponent(days)}${m}`);
};

export { apiReports };
